/**
 * Google Tag Manager Integration
 */
export default class GTMAnalytics {
	constructor() {
		this.initialize();
	}

	initialize() {
		try {
			this.loadGTMScript();
			this.loadGTMNoscript();
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Failed to initialize Google Tag Manager:', error);
		}
	}

	loadGTMScript() {
		if (window.dataLayer) {
			return;
		}

		const script = document.createElement('script');
		script.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-WZ7DTVH');`;

		document.head.appendChild(script);
	}

	/**
	 * Load GTM noscript fallback - must be placed immediately after opening <body> tag
	 * This provides tracking for users with JavaScript disabled
	 */
	loadGTMNoscript() {
		// Check if noscript already exists
		if (document.getElementById('gtm-noscript-fallback')) {
			return;
		}

		const noscript = document.createElement('noscript');
		noscript.id = 'gtm-noscript-fallback';

		const iframe = document.createElement('iframe');
		iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-WZ7DTVH';
		iframe.height = '0';
		iframe.width = '0';
		iframe.style.cssText = 'display:none;visibility:hidden';

		noscript.appendChild(iframe);

		// Insert immediately after body tag if it exists
		document.body.insertBefore(noscript, document.body.firstChild);
	}
}
